module.exports = __webpack_public_path__ + "media/application/images/svgs/corner-up-left-9ab679c600d1587779bec43327cccabc.svg";